import urlTemplate from "url-template";

export default (pattern = "", params = {}) =>
  urlTemplate.parse(pattern).expand(params);
